import { useQuery } from '@tanstack/react-query';
import { projectDataClient } from '../../lib/connect/clients';
/**
 * Whether the viewer may read this proposal's pricing (CheckPricingAccess, PRP-02/08).
 * True only on an explicit allow: loading, RPC error, not_found and deny all
 * read false so Pricing never flashes before the answer lands.
 */ export function useCanReadProposalPricing(projectId) {
    const query = useQuery({
        queryKey: [
            'proposal-pricing-access',
            projectId,
            'read'
        ],
        queryFn: ()=>projectDataClient.checkPricingAccess({
                projectId,
                action: 'read'
            }),
        enabled: !!projectId
    });
    return query.data?.allowed === true;
}
